import apiClient from '../config/api';

const productService = {
  /**
   * Get all products for the current tenant
   * @returns {Promise} Array of products
   */
  getAllProducts: async () => {
    const response = await apiClient.get('/product');
    return response.data;
  },

  /**
   * Get product by ID
   * @param {number} id - Product ID
   * @returns {Promise} Product details
   */
  getProductById: async (id) => {
    const response = await apiClient.get(`/product/${id}`);
    return response.data;
  },

  /**
   * Get product by code
   * @param {string} productCode - Product code
   * @returns {Promise} Product details
   */
  getProductByCode: async (productCode) => {
    const response = await apiClient.get(`/product/code/${productCode}`);
    return response.data;
  },

  /**
   * Create a new product
   * @param {object} productData - Product data
   * @returns {Promise} Created product
   */
  createProduct: async (productData) => {
    const response = await apiClient.post('/product', productData);
    return response.data;
  },

  /**
   * Update product
   * @param {number} id - Product ID
   * @param {object} productData - Updated product data
   * @returns {Promise} Update result
   */
  updateProduct: async (id, productData) => {
    const response = await apiClient.post(`/product/update/${id}`, productData);
    return response.data;
  },

  /**
   * Delete product (soft delete)
   * @param {number} id - Product ID
   * @returns {Promise} Deletion result
   */
  deleteProduct: async (id) => {
    const response = await apiClient.post(`/product/delete/${id}`);
    return response.data;
  },
};

export default productService;

